import { useEffect, useState } from 'react';
import { useGetPaymentSchedule } from '../api/get-payment-schedule';
import { Field, Panel } from '../../../../layouts';
import DateBox from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import { useGetPaymentScheduleFilterData } from '../api/get-payment-schedule-filter-data';
import Box, { Item } from 'devextreme-react/box';
import { Item as ToolbarItem, Toolbar } from 'devextreme-react/toolbar';
import { Button } from "devextreme-react/button";
import { TextBox } from "devextreme-react/text-box";
import { RequiredRule, Validator } from "devextreme-react/validator";
import './PaymentScheduleSearch.scss'
import PaymentScheduleGrid from './PaymentScheduleGrid';
import { LoadPagePanel } from '../../../../components';

export default function PaymentScheduleSearch() {

	const filterData = useGetPaymentScheduleFilterData();

	const [date, setDate] = useState(new Date());
	const [productCatalogID, setProductCatalog] = useState<number | undefined>();
	const [prodQteGrpID, setProductGroup] = useState<number | undefined>();
	const [isPromo, setIsPromo] = useState<boolean | undefined>();
	const [storeNumber, setStoreNumber] = useState<string | undefined>();
	const [sku, setSKU] = useState<string | undefined>();
	const [itemDescription, setItemDescription] = useState<string | undefined>();

	useEffect(() => {

		if (filterData.data) {
			const productCatalogID = filterData.data.productCatalogs[0].productCatalogID;
			const prodQteGrpID = filterData.data.productGroups?.[0]?.prodQteGrpID;

			setProductCatalog(productCatalogID);
			setProductGroup(prodQteGrpID);
		}
	}, [filterData.data]);

	const paymentSchedule = useGetPaymentSchedule({ date, productCatalogID, prodQteGrpID, isPromo, storeNumber, sku, itemDescription });

	return (
		<>
			<Box className='payment-schedule-filter'>
				<Item ratio={2}>
					<Panel header="Payment Schedule Filter">
						<Box>
							<Item ratio={1}>
								<Field label='Date'>
									<DateBox
										showClearButton={false}
										value={date}
										onValueChanged={(e) => setDate(e.value)}
										className="required"
									>
										<Validator validationGroup='paymentScheduleValidationGroup'>
											<RequiredRule />
										</Validator>
									</DateBox>
								</Field>
								<Field label='Product Catalog'>
									<SelectBox
										value={productCatalogID}
										onValueChanged={(e) => setProductCatalog(e.value)}
										dataSource={filterData.data?.productCatalogs}
										valueExpr="productCatalogID"
										displayExpr="description"
										className="required"
									>
										<Validator validationGroup='paymentScheduleValidationGroup'>
											<RequiredRule />
										</Validator>
									</SelectBox>
								</Field>
								<Field label='Product Group'>
									<SelectBox
										value={prodQteGrpID}
										onValueChanged={(e) => setProductGroup(e.value)}
										dataSource={filterData.data?.productGroups}
										valueExpr="prodQteGrpID"
										displayExpr="description"
										className="required"
									>
										<Validator validationGroup='paymentScheduleValidationGroup'>
											<RequiredRule />
										</Validator>
									</SelectBox>
								</Field>
								<Field label='Price Type'>
									<SelectBox
										value={isPromo}
										onValueChanged={(e) => setIsPromo(e.value)}
										items={[{ value: undefined, text: 'All' }, { value: false, text: 'Standard' }, { value: true, text: 'Promo' }]}
										valueExpr="value"
										displayExpr="text"
										className="required"
									/>
								</Field>
							</Item>
							<Item ratio={1}>
								<Field label='Store Number'>
									<TextBox
										value={storeNumber}
										onValueChanged={(e) => setStoreNumber(e.value)}
									/>
								</Field>
								<Field label='SKU'>
									<TextBox
										value={sku}
										onValueChanged={(e) => setSKU(e.value)}
									/>
								</Field>
								<Field label='Item Description'>
									<TextBox
										value={itemDescription}
										onValueChanged={(e) => setItemDescription(e.value)}
									/>
								</Field>
							</Item>
						</Box>
						<Toolbar className='button-toolbar'>
							<ToolbarItem location='after'>
								<Button
									text="Search"
									className="save-button"
									validationGroup='paymentScheduleValidationGroup'
									onClick={(e) => {
										if (e.validationGroup.validate().isValid) {
											paymentSchedule.refetch();
										}
									}}>
								</Button>
							</ToolbarItem>
						</Toolbar>
					</Panel>
				</Item>
				<Item ratio={1}>
				</Item>
			</Box>

			<PaymentScheduleGrid
				records={paymentSchedule.data?.records ?? []}
				date={date}
				showClickSearch={!paymentSchedule.data}
			/>

			<LoadPagePanel visible={filterData.isLoading || paymentSchedule.isRefetching || paymentSchedule.isInitialLoading} />
		</>
	)
} 
